import React from 'react';

const FORMATS = ['csv', 'xlsx', 'pdf'];

const formatLabel = (fmt) => {
  if (fmt === 'xlsx') return 'Excel';
  if (fmt === 'pdf') return 'PDF';
  return 'CSV';
};

const formatButtonClass = (fmt) => {
  const base =
    'flex-1 min-w-[4.5rem] px-2.5 py-1.5 text-xs font-semibold rounded-md border-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed uppercase tracking-wide whitespace-nowrap';
  if (fmt === 'csv') {
    return `${base} border-emerald-300 bg-emerald-50 text-emerald-800 hover:bg-emerald-100 hover:border-emerald-400`;
  }
  if (fmt === 'xlsx') {
    return `${base} border-blue-300 bg-blue-50 text-blue-800 hover:bg-blue-100 hover:border-blue-400`;
  }
  return `${base} border-rose-300 bg-rose-50 text-rose-800 hover:bg-rose-100 hover:border-rose-400`;
};

/**
 * Single row CSV / Excel / PDF buttons, absolutely positioned below the export trigger.
 * Use panelEntered for fade + slide-in (set true after mount via rAF in parent).
 */
const SelectedExportFormatBar = ({
  show,
  isOpen,
  panelEntered: propPanelEntered,
  disabled,
  loading,
  onSelect,
  onExport,
  formats = ['csv', 'xlsx', 'pdf'],
  className = ''
}) => {
  const [internalPanelEntered, setInternalPanelEntered] = React.useState(false);
  const isVisible = show || isOpen;
  const isEnabled = !(disabled || loading);
  const handleSelect = onSelect || onExport;

  React.useEffect(() => {
    if (isVisible) {
      const raf = requestAnimationFrame(() => setInternalPanelEntered(true));
      return () => cancelAnimationFrame(raf);
    } else {
      setInternalPanelEntered(false);
    }
  }, [isVisible]);

  const activePanelEntered = propPanelEntered ?? internalPanelEntered;

  if (!isVisible) return null;

  return (
    <div
      role="group"
      aria-label="Export file format"
      className={`${className} absolute left-1/2 top-full z-[45] mt-2 flex w-max max-w-[calc(100vw-2rem)] flex-row gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2.5 shadow-lg ring-1 ring-black/5 transition-all duration-200 ease-out ${
        activePanelEntered
          ? '-translate-x-1/2 translate-y-0 opacity-100'
          : 'pointer-events-none -translate-x-1/2 -translate-y-1 opacity-0'
      }`}
    >
      {formats.map((fmt) => (
        <button
          key={fmt}
          type="button"
          disabled={!isEnabled}
          onClick={() => handleSelect?.(fmt)}
          className={formatButtonClass(fmt)}
        >
          {formatLabel(fmt)}
        </button>
      ))}
    </div>
  );
};

export default SelectedExportFormatBar;
